<template>
  <div id="box-reader">
    <div class="options-wrappers">
      <rounded-button
        height="30px"
        width="fit-content"
        position="center"
        @click="torchActive = !torchActive"
        :disabled="torchNotSupported || showKeyboard"
        v-if="cameraSupported == true"
      >
        <img src="/static/icons/torch.svg" height="18px" width="60px" />
      </rounded-button>
      <!-- v-if="getActiveUser.role == 2" -->
      <rounded-button
        height="30px"
        :isOutline="true"
        width="fit-content"
        position="center"
        v-if="cameraSupported == true"
        @click="showKeyboard = !showKeyboard"
      >
        <img
          v-if="!showKeyboard"
          src="/static/icons/keyboard1-icon.svg"
          height="25px"
          width="60px"
        />
        <img
          v-if="showKeyboard"
          src="/static/icons/camera-icon.svg"
          height="25px"
          width="60px"
        />
      </rounded-button>
      <rounded-button
        height="30px"
        position="center"
        :isOutline="true"
        width="fit-content"
        @click="switchCamera"
        :disabled="showKeyboard"
        v-if="cameraSupported == true"
      >
        <img src="/static/icons/on-off-button.svg" height="18px" width="60px" />
      </rounded-button>
    </div>
    <transition name="fade">
      <basic-card
        class="reader-wrapper"
        v-if="!showKeyboard && cameraSupported != false"
      >
        <qrcode-stream
          v-if="camera !== 'off'"
          :torch="torchActive"
          :isOutline="true"
          :camera="camera"
          @init="onInit"
          @decode="qrReaded"
        >
          <div class="loading-indicator" v-if="isLoading">
            <div class="loading-screen">
              <loader-ring />
            </div>
          </div>
        </qrcode-stream>
      </basic-card>
    </transition>
    <transition name="fade">
      <div class="keyboard-mode" v-if="showKeyboard || cameraSupported != true">
        <basic-input
          @keyup="handleKeyup"
          type="number"
          :label="$t('boxReader.keyboard.qrNumber')"
          :placeholder="$t('boxReader.keyboard.qrNumber')"
          class="qr-number"
          width="500px"
          v-model="QRNumber"
        />
        <div>
          <rounded-button
            @click="saveTypedQR"
            height="30px"
            width="200px"
            position="center"
            class="save-button"
          >
            {{ $t("boxReader.keyboard.qrNumber.save") }}
          </rounded-button>
        </div>
      </div>
    </transition>
    <div class="boxes-wrapper">
      <readed-boxes
        @removeBox="removeBox"
        :boxes="readedBoxes"
        :withKeyBoard="withKeyBoard"
      />
    </div>
  </div>
</template>

<script>
import ReadedBoxes from "./ReadedBoxes";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BoxReader",
  props: {},
  components: {
    ReadedBoxes
  },
  data: () => ({
    readedBoxes: [],
    isLoading: true,
    torchNotSupported: false,
    torchActive: false,
    camera: "auto",
    showKeyboard: false,
    QRNumber: undefined,
    withKeyBoard: [],
    cameraSupported: true
  }),
  created() {
    this.initCamera();
  },
  watch: {
    needTorch() {
      if (this.needTorch) {
        this.torchActive = true;
      } else {
        this.torchActive = false;
      }
    },
    cameraSupported() {
      if (this.cameraSupported != true) {
        this.showKeyboard = true;
      }
    },
    getQR: {
      immediate: true,
      handler() {
        this.readedBoxes = this.getQR;
      }
    }
  },
  computed: {
    ...mapGetters({
      getQR: "moving/getQR",
      getActiveUser: "user/getActiveUser",
      getWindowWidth: "layout/getWindowWidth"
    }),
    needTorch() {
      if (this.torchNotSupported) {
        return false;
      } else {
        if (this.getActiveUser.role !== 1) {
          return false;
        }
        if (
          !(
            this.$moment().format("HH") >= 20 ||
            this.$moment().format("HH") <= 6
          )
        ) {
          return false;
        }
        return true;
      }
    },
    detectMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem);
      });
    }
  },
  methods: {
    ...mapActions({
      readBoxByQR: "boxes/readBoxByQR"
    }),
    initCamera() {
      if (this.cameraSupported != true) {
        this.showKeyboard = true;
      }
      if (this.getWindowWidth >= 1000 && this.detectMobile != true) {
        this.cameraSupported = false;
      } else {
        this.cameraSupported = true;
      }
    },
    handleKeyup(evt) {
      if (evt.key === "Enter") {
        this.saveTypedQR();
      }
    },
    saveTypedQR() {
      const qrCode = Number(this.QRNumber);
      if (this.isNumber(qrCode)) {
        this.getBox(this.QRNumber, true);
        this.QRNumber = undefined;
      }
    },
    removeBox(item) {
      let index = this.readedBoxes.indexOf(item);
      this.readedBoxes.splice(index, 1);
      index = this.withKeyBoard.indexOf(item);
      this.withKeyBoard.splice(index, 1);
    },
    qrReaded(evt) {
      if (evt === "" || evt === " " || evt === null || evt === undefined) {
        return;
      }
      const qrCode = Number(evt);
      if (this.isNumber(qrCode)) {
        this.playSuccessSound();
        this.getBox(evt);
      }
    },
    getBox(id, withKeyBoard = false) {
      if (!this.isReadedYet(id)) {
        this.readedBoxes.push(id);
        if (withKeyBoard) {
          this.withKeyBoard.push(id);
        }
      }
    },
    isReadedYet(res) {
      return this.readedBoxes.some(x => {
        return x === res;
      });
    },
    switchCamera() {
      switch (this.camera) {
        case "off":
          this.camera = "auto";
          break;
        case "auto":
          this.camera = "off";
          break;
      }
    },
    playSuccessSound() {
      const audio = new Audio(require("@/assets/sounds/success.wav"));
      audio.play();
    },
    async onInit(promise) {
      // show loading indicator
      this.isLoading = true;
      this.cameraSupported = true;
      try {
        const { capabilities } = await promise;
        this.torchNotSupported = !capabilities.torch;
      } catch (error) {
        console.log(error);
        this.cameraSupported = false;
        // if (error.name === "NotAllowedError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // } else if (error.name === "NotFoundError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // } else if (error.name === "NotSupportedError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // } else if (error.name === "NotReadableError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // } else if (error.name === "OverconstrainedError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // } else if (error.name === "StreamApiNotSupportedError") {
        //   this.$notification.showNoti(
        //     "error",
        //     `boxReader.${error.name}`,
        //     undefined,
        //     6000
        //   );
        // }
      } finally {
        this.isLoading = false;
        // hide loading indicator
      }
    },
    isNumber(n) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    }
  }
};
</script>

<style lang="scss" scoped>
#box-reader {
  padding-top: 20px;
  .options-wrappers {
    margin-bottom: 10px;
    display: flex;
  }
  .reader-wrapper {
    height: fit-content;
    min-height: 50vh;
    height: 50vh;
    width: 100%;
    padding: 0;
    margin-bottom: 20px;
    /deep/ .qrcode-stream-wrapper {
      .qrcode-stream-overlay {
        .loading-indicator {
          height: 50vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .qrcode-stream-camera {
        border-radius: 8px;
      }
    }
  }
  .keyboard-mode {
    margin-top: 20px;
    .qr-number {
      max-width: 100%;
      margin: auto;
      margin-bottom: 10px;
    }
    .save-button {
      margin-bottom: 30px;
    }
  }
  .boxes-wrapper {
    margin-bottom: 20px;
  }
}
</style>
